module.exports = __webpack_public_path__ + "img/uy.a789fb28.svg";